import { useState, useCallback, useEffect } from 'react';
import {KEYCLOACK_URL, KEYCLOACK_BODY} from '../src/config/urlKeycloack';
//import CryptoJS from 'crypto-js';


export default function useTokenKeycloack() {

    const fetchAccessToken =  useCallback(async () => {
        try {

            //console.log("KEYCLOACK_URL: "+KEYCLOACK_URL);
            //console.log("KEYCLOACK_BODY:"+KEYCLOACK_BODY);

            //const encrypteBody = CryptoJS.AES.encrypt(KEYCLOACK_BODY, 'secret-key').toString();

            const response = await fetch(`${KEYCLOACK_URL}`, {
                method: 'POST',
                //mode: 'no-cors',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: KEYCLOACK_BODY
                //body: encrypteBody
            });

            //console.log(response);
            if (!response.ok) {
                const errorDetails = await response.text(); 
                console.log('Failed to connect to Keycloak: ' + response.statusText + " - " + errorDetails);
                throw new Error('Failed to connect to Keycloak: ' + response.statusText + " - " + errorDetails);
            }

            const data = await response.json();

            //console.log("Pegou token: "+data);
            sessionStorage.setItem('token_keycloack', data.access_token);
            setTokenKeycloack(data.access_token);
            return data.access_token;

        } catch (error) {
            console.error("Internal error: " + error);
            return null;
        }
    }, []); 

    useEffect(() => {
        fetchAccessToken();
    }, [fetchAccessToken]);

    const [tokenKeyCloack, setTokenKeycloack] = useState(null);

    return { fetchAccessToken, tokenKeyCloack: tokenKeyCloack };  

    

}